import React from 'react';
import { Flex, Heading, Box, Text, Input, Button, Spinner, FormControl, FormLabel, Icon } from '@chakra-ui/react';
import moment from 'moment';
import { AiOutlineFilter, AiOutlineClear } from 'react-icons/ai';

const DashboardHeader = ({
    title,
    periodText,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    onFilterClick,
    onClearFilter,
    isDisabled
}) => {
    return (
        <Flex
            w="100%"
            direction={{ base: 'column', lg: 'row' }}
            align={{ base: 'flex-start', lg: 'center' }}
            justify="space-between"
            gap={4}
            pb={4}
            mb={6}
            borderBottom="1px solid"
            borderColor="gray.800"
        >
            <Box mb={{ base: 4, lg: 0 }}>
                <Heading as="h1" size="lg" color="white">
                    {title}
                </Heading>
                <Text fontSize="sm" color="gray.400">{periodText}</Text>
            </Box>

            <Flex
                align="flex-end"
                gap={3}
                w={{ base: '100%', lg: 'auto' }}
                justify={{ base: 'space-between', lg: 'flex-end' }}
                flexWrap={{ base: 'wrap', md: 'nowrap' }}
            >
                <FormControl w={{ base: 'calc(50% - 12px)', md: 'auto' }}>
                    <FormLabel htmlFor="startDate" fontSize="xs" color="gray.400" mb={1}>
                        Data Inicial
                    </FormLabel>
                    <Input
                        id="startDate" type="date" size="sm" value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        max={endDate || undefined} bg="gray.700" borderColor="gray.600"
                        color="white" borderRadius="md" _hover={{ borderColor: 'gray.500' }}
                        _focus={{ borderColor: 'green.500', boxShadow: '0 0 0 1px var(--chakra-colors-green-500)' }}
                        minW="130px"
                    />
                </FormControl>

                <FormControl w={{ base: 'calc(50% - 12px)', md: 'auto' }}>
                    <FormLabel htmlFor="endDate" fontSize="xs" color="gray.400" mb={1}>
                        Data Final
                    </FormLabel>
                    <Input
                        id="endDate" type="date" size="sm" value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        min={startDate || undefined}
                        bg="gray.700" borderColor="gray.600" color="white"
                        borderRadius="md" _hover={{ borderColor: 'gray.500' }}
                        _focus={{ borderColor: 'green.500', boxShadow: '0 0 0 1px var(--chakra-colors-green-500)' }}
                        minW="130px"
                    />
                </FormControl>

                <Button
                    colorScheme="green"
                    size="sm"
                    onClick={onFilterClick}
                    isDisabled={isDisabled}
                    leftIcon={isDisabled ? undefined : <Icon as={AiOutlineFilter} boxSize={4} />}
                    minW="90px"
                    px={3}
                    mt={{ base: 2, md: 0 }}
                    alignSelf={{ base: 'stretch', md: 'flex-end' }}
                >
                    {isDisabled ? <Spinner size="sm" /> : 'Filtrar'}
                </Button>

                <Button
                    variant="outline"
                    colorScheme="gray"
                    size="sm"
                    onClick={onClearFilter}
                    isDisabled={isDisabled}
                    leftIcon={<Icon as={AiOutlineClear} boxSize={4} />}
                    minW="90px"
                    px={3}
                    mt={{ base: 2, md: 0 }}
                    alignSelf={{ base: 'stretch', md: 'flex-end' }}
                    borderColor="gray.600"
                    _hover={{ bg: 'gray.600' }}
                >
                    Limpar
                </Button>

            </Flex>
        </Flex>
    );
};

export default DashboardHeader;